const client = require('sci/helpers/queue-client')

const {gql} = require('@apollo/client/core')

const {print} = require('graphql/language/printer')

const tasksRegistry = require('./registry')

const outputs = tasksRegistry.map(
    task => task.output ? `
        ${task.taskName} ${print(task.output)}
    ` : ''
).join("\n")

const inputs = tasksRegistry.map(
    task => task.input ? `
        ${task.taskName} ${print(task.input)}
    ` : ''
).join("\n")

const FragTask = gql`
fragment FragTask on Task {
    id
    alias
    scope
    status
    humanName
    humanDescription
    createdAt
    updatedAt
    progress {
      alias
      percentage
    }
    logs {
        level
        message
        createdAt
    }
    input {
        _is
        ${inputs}
    }
    output {
        _is
        ${outputs}
    }
}
`

const statusesNames = {
    WAITING: {label: 'Aguardando execução...', class: null},
    RUNNING: {label: 'Executando', class: 'text-info'},
    CANCELLED: {label: 'Cancelado', class: 'text-warning'},
    FAILED: {label: 'Falhou', class: 'text-danger'},
    DONE: {label: 'Concluído', class: 'text-success'},
    ABORTED: {label: 'Abortado', class: 'text-danger'},
}

const makeTask = (task) => {
    task.output = task.output[task.alias]
    task.input = task.input[task.alias] || null
    task.humanStatus = statusesNames[task.status]

    return task
}

module.exports = {
    statusesNames,
    findRegisteredTask(name, version) {
        return client().query({
            query: gql`
                query($name: String!, $version: Long!) {
                    registeredTask(name: $name, version: $version) {
                        name
                        version
                        humanName
                        humanDescription
                    }
                }
            `,
            variables: {
                name,
                version
            }
        }).then((res) => {
            return res.data.registeredTask
        })
    },
    enqueue(taskId, version, input) {
        const task = tasksRegistry.find(_ => _.id === taskId && _.version === version)

        if (!task) {
            throw new Error("Task not found in registry.js")
        }

        return client().mutate({
            mutation: gql`
                mutation($input: ${task.inputName}!) {
                    result: ${task.enqueueMutationName}(input: $input)
                }
            `,
            variables: {
                input
            }
        }).then((res) => {
            return res.data.result
        })
    },
    find(taskId) {
        return client().query({
            query: gql`
                ${FragTask}
                query($id: Long!) {
                    task(id: $id) {
                        ...FragTask
                    }
                }
            `,
            variables: {
                id: taskId
            }
        }).then((res) => {
            return makeTask(res.data.task)
        })
    },
    list() {
        return client().query({
            query: gql`
                ${FragTask}
                query {
                    tasks {
                        ...FragTask
                    }
                }
            `,
            variables: {}
        }).then((res) => {
            return res.data.tasks.map(makeTask)
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/javascript/components/queue/helpers.js